import axios from 'axios';

const API = process.env.REACT_APP_API_URL || 'http://localhost:5000';
const axiosInstance = axios.create({ baseURL: API, withCredentials: true });

export const generatePairingCode = async (phoneNumber, schoolId) => {
  const response = await axiosInstance.post('/api/owner/whatsapp/pair-code', {
    phoneNumber,
    schoolId,
  });
  return response.data;
};

export const reconnectSession = async (schoolId) => {
  // schoolId is optional — backend falls back to req.user.schoolId from the auth cookie
  const response = await axiosInstance.post('/api/owner/whatsapp/reconnect', {
    schoolId,
  });
  return response.data;
};

export const getSessionStatus = async () => {
  // schoolId is resolved server-side from the authenticated owner's cookie
  const response = await axiosInstance.get('/api/owner/whatsapp/status');
  return response.data;
};

export const checkNumber = async (phoneNumber) => {
  // schoolId is resolved server-side from the authenticated owner's cookie
  const response = await axiosInstance.post('/api/owner/whatsapp/check-number', {
    phoneNumber,
  });
  return response.data;
};